import LegalPageLayout from '../components/LegalPageLayout';

const sections = [
  {
    id: 'introduction',
    title: 'Introduction',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Welcome to IASC Consultancy. These Terms and Conditions govern your use of our services, including
          international education consulting, job placement assistance, and visa advisory services. By engaging
          with our firm, you acknowledge that you have read, understood, and agreed to be bound by these terms.
        </p>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          IASC Consultancy ("we", "us", "our") provides a platform and advisory network to connect qualified
          candidates with global opportunities. Our mission is to ensure transparency and ethical practice in
          every step of your international journey.
        </p>
      </>
    ),
  },
  {
    id: 'services',
    title: 'Scope of Services',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Our services are designed to facilitate your professional and academic advancement. These include but
          are not limited to:
        </p>
        <ul className="list-disc list-outside ml-6 mb-6 space-y-3 text-[#44474f]">
          <li>Assessment of academic and professional credentials.</li>
          <li>Strategic mapping of international educational institutions.</li>
          <li>Corporate placement through our network of global partners.</li>
          <li>Guidance on visa application procedures and documentation.</li>
          <li>Pre-departure orientation and cultural integration support.</li>
        </ul>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Please note that IASC Consultancy acts as an intermediary. While we strive for the best possible
          outcome, final admission or employment decisions rest solely with the third-party institutions or
          employers.
        </p>
      </>
    ),
  },
  {
    id: 'obligations',
    title: 'Client Obligations',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          To provide high-quality consultancy, we require full cooperation from our clients. You agree to:
        </p>
        <ul className="list-disc list-outside ml-6 mb-6 space-y-3 text-[#44474f]">
          <li>Provide accurate, truthful, and complete information regarding your history and credentials.</li>
          <li>Meet all deadlines set by institutions or government agencies.</li>
          <li>Maintain professional conduct during interviews and communications with partners.</li>
          <li>Report any changes in your status that might affect your application immediately.</li>
        </ul>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Submission of fraudulent documents will result in immediate termination of services without refund and
          may be reported to relevant authorities.
        </p>
      </>
    ),
  },
  {
    id: 'fees',
    title: 'Fees & Payments',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Consultancy fees are structured based on the specific service package selected. Detailed fee schedules
          are provided in your personalized Service Agreement.
        </p>
        <h3 className="text-lg font-semibold text-[#365da3] mt-8 mb-4">Refund Policy</h3>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Standard administrative fees are non-refundable once the assessment process has commenced. Partial
          refunds may be considered in exceptional circumstances, such as institutional program cancellations or
          visa/work permit denial, as detailed in your individual service agreement.
        </p>
      </>
    ),
  },
  {
    id: 'privacy',
    title: 'Data Privacy',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          Your privacy is paramount. We collect and process personal data in accordance with our{' '}
          <a href="/privacy" className="text-[#00255a] font-semibold hover:underline">Privacy Policy</a>. By using
          our services, you consent to the sharing of necessary data with prospective employers, universities, and
          visa processing agencies as required for your application.
        </p>
        <p className="text-[#44474f] mb-6 leading-relaxed">
          We employ industry-standard encryption and strict internal protocols to protect your sensitive
          documentation from unauthorized access.
        </p>
      </>
    ),
  },
  {
    id: 'termination',
    title: 'Termination',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        Either party may terminate the engagement with written notice. In the event of termination, the client
        remains responsible for fees incurred for services already rendered up to the date of notice.
      </p>
    ),
  },
  {
    id: 'liability',
    title: 'Limitation of Liability',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        IASC Consultancy shall not be liable for any indirect, incidental, or consequential damages resulting from
        the rejection of applications by third parties. Our total liability under any circumstances shall not
        exceed the total fees paid by the client to the firm.
      </p>
    ),
  },
  {
    id: 'governing',
    title: 'Governing Law',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        These terms are governed by and construed in accordance with the laws of the jurisdiction in which IASC
        Consultancy is registered. Any disputes arising from these terms shall be subject to the exclusive
        jurisdiction of the local courts.
      </p>
    ),
  },
];

export default function TermsPage() {
  return <LegalPageLayout title="Terms and Conditions" lastUpdated="August 6, 2026" sections={sections} />;
}